import { Modals, useModals } from "@/hooks/useModals"
import Modal from "@/components/Modal"
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react"
import clsx from "clsx"
import { PlusCircleIcon, XCircleIcon } from "@heroicons/react/24/outline"
import { Fragment } from "react"
import { faqs, supportEmail } from "@/constants"

const HelpModal = () => {
  const { activeModal, closeModal } = useModals()
  const isOpen = activeModal === Modals.Help

  return (
    <Modal
      show={isOpen}
      onClose={() => closeModal()}
      title="Help & Support"
      maxWidthClassName="sm:max-w-xl"
    >
      <div className="font-base space-y-2 py-6 text-gray-600 sm:py-8">
        <p>
          If you have any questions, feel free to reach out to us at{" "}
          <a
            href={`mailto:${supportEmail}`}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-gray-900 hover:underline"
          >
            {supportEmail}
          </a>
          .
        </p>
        <p>Below are some frequently asked questions that might help you.</p>
      </div>
      <ul className="mx-auto max-w-3xl divide-y divide-gray-200 border-y border-gray-200">
        {faqs.map(({ question, answer }) => (
          <Disclosure key={question} as="li">
            {({ open }) => (
              <>
                <DisclosureButton
                  className={clsx(
                    "group flex w-full items-start justify-between gap-4 text-left text-gray-900",
                    open ? "pt-4 pb-1" : "py-4"
                  )}
                >
                  <h3 className="text-base leading-6 font-semibold text-gray-900">
                    {question}
                  </h3>
                  {open ? (
                    <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-gray-400" />
                  ) : (
                    <PlusCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-gray-400" />
                  )}
                </DisclosureButton>
                <DisclosurePanel as={Fragment}>
                  <p className="pb-4 text-sm text-gray-600">{answer}</p>
                </DisclosurePanel>
              </>
            )}
          </Disclosure>
        ))}
      </ul>
    </Modal>
  )
}

export default HelpModal
